import axios from "axios";
import { Component } from "react";
import { baseUrl, config } from './index.js';

export default class AuthService extends Component {
  static login = async (data) => {
    try {
      const response = await axios.post(baseUrl + `/jwt-auth/v1/token`, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) { console.log(`FETCH GET ERROR`, response); return; }
      return response.data ? response.data : [];
    }
  };

  static register = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/sites_create_users';
      config.method = 'post';
      config.data = data;
      config.params = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) { console.log(`FETCH GET ERROR`, response); return; }
      return response.data ? response.data : [];
    }
  };

  static forgotPassword = async (data) => {
    try {
      console.log("dmeo===", data)
      config.url = baseUrl + '/wp/v2/lost_password';
      config.method = 'post';
      config.data = data;
      config.params = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) { console.log(`FETCH GET ERROR`, response); return; }
      return response.data ? response.data : [];
    }
  };

  static setForgetPwd = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/reset_password ';
      config.method = 'post';
      config.data = data;
      config.params = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) { console.log(`FETCH GET ERROR`, response); return; }
      return response.data ? response.data : [];
    }
  };

  static setNewPwd = async (data) => {
    try {
      console.log("dmeo===", data)
      config.url = baseUrl + '/wp/v2/set_new_password   ';
      config.method = 'post';
      config.data = data;
      config.params = '';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) { console.log(`FETCH GET ERROR`, response); return; }
      return response.data ? response.data : [];
    }
  };

  static logout = async () => {
    try {
      config.url = baseUrl + 'mobile-logout';
      config.method = 'post';
      const response = await axios(config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static changePassword = async (data) => {
    try {
      const response = await axios.post(baseUrl + `mobile-change-password`, data, config);
      return response.data ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getAuthImage = async () => {
    try {
      config.url = baseUrl + '/wp/v2/login_page';
      config.method = "get";
      config.params = '';
      const response = await axios(config);
      return response ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

}
